import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';

// Il rewrite statico di Render (/* -> /index.html) risponde sempre 200, quindi un indirizzo inesistente non può
// restituire un vero 404. Qui lo si dichiara come non indicizzabile: noindex finché la rotta è montata.
export default function NotFound() {
  useEffect(() => {
    // index.html ha già un meta robots "index, follow": si modifica quello (e lo si ripristina), non se ne aggiunge un secondo in conflitto.
    let meta = document.querySelector('meta[name="robots"]');
    const created = !meta;
    if (created) {
      meta = document.createElement('meta');
      meta.name = 'robots';
      document.head.appendChild(meta);
    }
    const previousRobots = meta.content;
    meta.content = 'noindex';
    const previousTitle = document.title;
    document.title = '404 · Pagina non trovata / Page not found';
    return () => {
      if (created) meta.remove();
      else meta.content = previousRobots;
      document.title = previousTitle;
    };
  }, []);

  return (
    <section className="min-h-screen flex flex-col items-center justify-center gap-4 px-4 text-center" data-testid="not-found">
      <p className="text-6xl font-bold">404</p>
      <h1 className="text-xl">Pagina non trovata · Page not found</h1>
      <Link to="/" className="underline">Torna alla home · Back to home</Link>
    </section>
  );
}
